import { useParams, Link } from 'react-router-dom';
import Markdown from '../components/Markdown';
import { getDocContent } from '../docs/content-loader';
import { docsManifest } from '../docs/manifest';

export default function DocPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug ?? 'index';
  const content = getDocContent(activeSlug);

  if (!content) {
    return (
      <div>
        <h1 className="mb-3 text-2xl font-bold text-slate-900">Page not found</h1>
        <p className="text-slate-600">
          No documentation exists for “{activeSlug}”.{' '}
          <Link to="/docs" className="text-blue-600 hover:underline">
            Back to overview
          </Link>
          .
        </p>
      </div>
    );
  }

  const idx = docsManifest.findIndex((e) => e.slug === activeSlug);
  const next = idx >= 0 && idx < docsManifest.length - 1 ? docsManifest[idx + 1] : undefined;

  return (
    <article>
      <Markdown content={content} />
      {next && (
        <div className="mt-12 border-t border-slate-200 pt-4">
          <Link
            to={next.slug === 'index' ? '/docs' : `/docs/${next.slug}`}
            className="text-sm text-slate-500 hover:text-slate-800"
          >
            Next: <span className="font-medium text-blue-600">{next.title}</span> →
          </Link>
        </div>
      )}
    </article>
  );
}
